import React, {Component} from 'react'
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {Icon, Button, Col, Row, Modal} from 'antd';
import * as APP_CONFIG from "../constants/config";
import {withRouter} from "react-router";
import moment from 'moment';
const {DateTimeFormat, DateFormat} = APP_CONFIG;


class Action extends Component {
    static propTypes = {
        actie: PropTypes.object.isRequired,
        malfunctionid: PropTypes.number.isRequired
    };

    static defaultProps = {
        actie: {
            id: 0,
            datum_gepland: '01-01-1900',
            datum_uitgevoerd: '01-01-1900',
            wat_te_doen: '',
            meenemen: '',
            opgelost: false,
            oplossingtype: 'Overig',
            oplossingtypeother: '',
            gecommuniceerd_klant: false,
            uren_besteed: 0.0,
            opmerkingen: ''
        }
    };

    constructor(props) {
        super(props);
        this.state = {
            actie: props.actie,
            malfunction: this.getMalfunction(props),
            malfunctionid: props.malfunctionid,
            modalVisible: false,
        }
    }

    getMalfunction = ({ malfunctions, malfunctionid }) => {
        let malfunction = null;
        //console.log(`getMalfunction, ${malfunctions.length}, ${malfunctionid}`);
        malfunctions.forEach((element) => {
            if(element.id === parseInt(malfunctionid,10))
                malfunction = element;
        });
        return malfunction;
    };

    toEdit = (id, malfunctionid) => {
        this.props.history.push(`/storingen/${malfunctionid}/actions/${id}`);
    };

    renderPrint = () => {
        const {malfunction, actie} = this.state;
        const styles = {
            label: {border: '1px solid #27B5B2', backgroundColor: '#27B5B2', height: '60px', float: 'left', width: '25%', color: '#fff', padding: '4px 6px', fontWeight: 'bold', margin: '0 0 4px 0', '-webkit-print-color-adjust': 'exact', boxSizing: 'border-box'},
            value: {border: '1px solid #27B5B2', backgroundColor: '#FFF', height: '60px', float: 'left', width: '24%', padding: '4px 6px', margin: '0 1% 4px 0', boxSizing: 'border-box'},
            blockLabel: {color: '#EF7F22', float: 'left', width: '100%', padding: '4px 6px', fontWeight: 'bold', margin: '8px 0 4px 0', boxSizing: 'border-box'},
            blockValue: {border: '1px solid #27B5B2', backgroundColor: '#27B5B2', color: '#fff', height: '160px', float: 'left', width: '100%', padding: '4px 6px', '-webkit-print-color-adjust': 'exact', margin: '0 1% 4px 0', boxSizing: 'border-box'},
        }
        return (
            <div id="printme">
                <div style={{width: '670px', margin: '0 auto', boxSizing: 'border-box'}}>
                    <div style={styles.label}>Klantnaam</div>
                    <div style={styles.value}>{malfunction.klant}</div>
                    <div style={styles.label}>Locatie</div>
                    <div style={styles.value}>{malfunction.locatie}</div>

                    <div style={styles.label}>Aanmelddatum</div>
                    <div style={styles.value}>{moment(malfunction.aanmeldingsdatum).format(DateFormat)}</div>
                    <div style={styles.label}>Storingtype</div>
                    <div style={styles.value}>{malfunction.storingtype}</div>

                    <div style={styles.label}>Adres</div>
                    <div style={styles.value}>#blamekevin</div>
                    <div style={styles.label}>Datum/tijd afspraak</div>
                    <div style={styles.value}>{moment(actie.datum_gepland).format(DateTimeFormat)}</div>

                    <div style={styles.label}>Contactpersoon</div>
                    <div style={styles.value}>{malfunction.contactpersoon}</div>
                    <div style={styles.label}>Contactgegevens</div>
                    <div style={styles.value}>{malfunction.contactgegevens}</div>

                    <div style={styles.label}>Omschrijving storing</div>
                    <div style={{...styles.value, width: '74%'}}>{malfunction.beschrijving}</div>

                    <div style={styles.blockLabel}>Beschrijving actie</div>
                    <div style={styles.blockValue}>{actie.wat_te_doen}</div>

                    <div style={styles.blockLabel}>Materialen</div>
                    <div style={styles.blockValue}>{actie.meenemen}</div>

                    <div style={styles.blockLabel}>Opmerkingen</div>
                    <div style={styles.blockValue}>{actie.opmerkingen}</div>


                    <div style={{clear: 'both'}}>&nbsp;</div>
                </div>
            </div>
        );
    }

    showModal = () => {
        this.setState({modalVisible: true});
    }

    handleCancel = () => {
        this.setState({
            modalVisible: false,
        });
    }

    print = () => {

        var mywindow = window.open('', 'PRINT', 'height=400,width=600');

        mywindow.document.write('<html><head><title>Storingsformulier ' + this.state.malfunction.klant  + ' - ' + this.state.malfunction.locatie +  '</title>');
        mywindow.document.write('<style> @page {size: auto;margin: 0mm} body{background-color:#FFFFFF;margin: 0px;padding-top:40px;}</style>');
        mywindow.document.write('</head><body >');
        mywindow.document.write(document.getElementById('printme').innerHTML);
        mywindow.document.write('</body></html>');

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/

        mywindow.print();
        mywindow.close();

        return true;
    }

    render() {
        const item = this.state.actie;
        const {malfunctionid} = this.state;

        let datum_gepland = item.datum_gepland ? moment(item.datum_gepland).format(DateTimeFormat) : '';
        let datum_uitgevoerd = item.datum_uitgevoerd ? moment(item.datum_uitgevoerd).format(DateFormat) : '';

        const actionDivStyle = {
            background: 'lightBlue',
            borderBottom: 'solid',
            borderColor: 'white'
        }

        return (
            <div style={actionDivStyle}>
                <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                    <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Gepland op</Col>
                    <Col xs={24} md={9} className="dataview-value">
                        {datum_gepland} {/*<Link to={`/storingen/${malfunctionid}/actions/${item.id}`} >
                        <Icon type="edit" /> </Link>*/}&nbsp;<Icon style={{visibility : item.fotos.length ? 'visible' : 'hidden'}} type="camera" /></Col>
                    <Col xs={24} md={7} className="dataview-value">
                        <Button type="primary" onClick={()=>this.toEdit(item.id, malfunctionid)}>Aanpassen</Button>
                    </Col>
                    <Col xs={24} md={3} className="dataview-value">
                        <Modal
                            title="Printversie"
                            visible={this.state.modalVisible}
                            width={800}
                            height={800}
                            onCancel={() => this.handleCancel()}
                            afterClose={() => this.handleCancel()}
                            footer={[
                                <Button key="cancel" type="primary" onClick={() => this.handleCancel()}>Cancel</Button>,
                                <Button key="submit" type="primary" onClick={() => this.print()}>
                                    Print
                                </Button>
                            ]}
                        >
                            {this.renderPrint()}
                        </Modal>
                        <Button type="primary" onClick={() => this.showModal()}><Icon type="printer" /></Button>
                    </Col>
                </Row>
                <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                    <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Uitgevoerd op</Col>
                    <Col xs={24} md={16} className="dataview-value">{datum_uitgevoerd}</Col>
                </Row>
                <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                    <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Opgelost</Col>
                    <Col xs={24} md={16} className="dataview-value">
                        <input type="checkbox" disabled={true} checked={item.opgelost} /></Col>
                </Row>
                {
                    item.opgelost ? (
                        <Row gutter={{xs: 0, md: 24}} className="dataview-row">
                            <Col xs={24} md={5} className="dataview-label" style={{fontWeight:'bold'}}>Oplossing</Col>
                            <Col xs={24} md={16} className="dataview-value">
                                {(item.oplossingtype === 'Overig' ? "Overig: " + item.oplossingtypeother : item.oplossingtype)}
                            </Col>
                        </Row>
                    ) : ''
                }
            </div>
        );
    }
}

let mapStateToProps = ({malfunctions}) => ({
    malfunctions: [...malfunctions.malfunctions]
});

export default withRouter(connect(mapStateToProps)(Action));



// WEBPACK FOOTER //
// ./src/components/Action.js